export const PRICING_MODAL_CLICK_ID_KEY = 'pricingClickId';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
